module.exports = __webpack_public_path__ + "img/styles-dark-thumb.b2eb24ee.png";